import template from "./index.html";
import moment from "moment";

export function controller(
	config
) {
	const ctrl = this;

	ctrl.handleClose = handleClose;
	ctrl.$onInit = onInit;
	ctrl.$onDestroy = handleClose;
	ctrl.config = config;

	function onInit() {
		// eslint-disable-next-line no-undef
		const localBuildDate = moment(moment.utc(BUILD_DATE).toDate());

		ctrl.buildDate = localBuildDate.format("MMMM Do YYYY, h:mm:ss a");
		ctrl.timeSinceBuildDate = localBuildDate.fromNow();
	}

	function handleClose() {
		ctrl.modalInstance.close();
	}
}

export default angular
	.module("vesl.components.build-information-modal", [])
	.component("buildInformationModal", {
		controller,
		template,
		bindings: {
			close: "&",
			dismiss: "&",
			modalInstance: "<"
		}
	}).name;
